// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"4172": "d475d337","6259": "5350f194","6264": "0da7c3e2",}[chunkId] + ".css"
}